import { ArrowUpDown } from "lucide-react"
import { SortDisplayT, getSortOrderIcon } from "shared-ts/hooks/useSort/helpers"

import {
  ButtonMode,
  ButtonProps,
} from "../../../../../components/base/control/Button"
import { DropdownButton } from "../../DropdownButton/DropdownButton"

export type SortButtonMode =
  | typeof ButtonMode.Secondary
  | typeof ButtonMode.Ghost

interface SortButtonProps extends Omit<ButtonProps, "mode" | "tone"> {
  sort: SortDisplayT | null
  mode?: SortButtonMode
}

export const SortButton = ({
  sort: sort,
  mode = ButtonMode.Secondary,
  onClick,
  disabled,
  ref,
}: SortButtonProps) => {
  const icon = !sort ? ArrowUpDown : getSortOrderIcon(sort.order)
  const hideDropdownIcon = !sort
  const selected = !!sort
  const label = sort ? sort.label : "Sort"

  return (
    <DropdownButton
      ref={ref}
      icon={icon}
      label={label}
      mode={mode}
      selected={selected}
      hideDropdownIcon={hideDropdownIcon}
      onClick={onClick}
      disabled={disabled}
    />
  )
}
